// Decide what the peptide cart's session-identity effect should do for a given
// auth transition. Pulled out of usePeptideCart so the logic is unit-testable
// without rendering the whole cart/pricing provider tree.
//
// The bug this guards against: useAuth initializes `auth` to undefined and only
// resolves it to a value (logged in) or null (logged out) once checkAuth
// finishes. Treating the undefined hydration window as a logout wiped every
// sessionStorage cart key on the first effect pass of every page refresh,
// before auth had a chance to resolve.
//
// Returns one of:
//   "hydrating" — auth not yet resolved and no identity → do nothing
//   "logout"    — auth resolved to no session → save cart to localStorage + wipe
//   "switch"    — identity present and differs from previous → load this session
//   "noop"      — identity unchanged → nothing to do
export function classifyCartSessionTransition({ prevIdentity, sessionIdentity, authResolved }) {
  if (!sessionIdentity) {
    if (!authResolved) return "hydrating";
    return "logout";
  }
  if (prevIdentity !== sessionIdentity) return "switch";
  return "noop";
}
